import type { HelpFile } from '../../types/help'
import { TagInputTestIds } from '../../../testids/TagInputTestIds'

export const tagInputHelp: HelpFile = {
  texts: {
    [TagInputTestIds.validationError]:
      'A tag you entered failed validation — for example duplicate, empty, or not in the allowed value list.',
    [TagInputTestIds.validationHint]:
      'Tip describing what kind of values are accepted in this tag input.',
  },
}
